export function shouldClearPreviewForVisibleNodeIds(
	previewedNodeId: string | null,
	visibleNodeIds: string[]
): boolean {
	if (!previewedNodeId) return false;
	return !visibleNodeIds.includes(previewedNodeId);
}
